import {
  BooleanStatusIndicator,
  BooleanStatusIndicatorProps,
} from "@/common/components/Status/BooleanStatusIndicator";
import { OperabilityStatus } from "@/core/api/generated/v1";

interface Props {
  status: OperabilityStatus | undefined;
  indicatorProps?: Partial<BooleanStatusIndicatorProps>;
}

export function OperabilityStatusIndicator({ status, indicatorProps }: Props) {
  return (
    <BooleanStatusIndicator
      value={status === OperabilityStatus.Operable}
      size='small'
      {...indicatorProps}
    />
  );
}
